module.exports = "<div class=\"btn-group\" uib-dropdown>\n    <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.hideCustomer()\"\n        ng-class=\"{'btn-primary': !$ctrl.multiple, 'btn-default': $ctrl.multiple}\" ladda=\"$ctrl.loading\">\n        <span ng-if=\"$ctrl.isHidden\">Show this customer</span>\n        <span ng-if=\"!$ctrl.isHidden\">Hide this customer</span>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/hide-customer.button/hide-customer.button.html
// module id = 701
// module chunks = 0